const DROP_POSITION = {
  TOP: "top",
  BOTTOM: "bottom",
  CENTER: "center",
  LEFT: "left",
  RIGHT: "right"
};

const ROW_DROP_POSITIONS = ["left", "right"];

export { DROP_POSITION, ROW_DROP_POSITIONS };
